export default __webpack_public_path__ + "static/media/Error-Icon.47e8e326.svg";